import { Redirect, Route, Router, Switch, useHistory, useRouteMatch } from "react-router";
import EnterOTP from "../onboarding/enterOTP"
import EnterPAN, { EnterEmailId, EnterMobile } from "../onboarding/enterPAN"
import InvOnboardingLayout from "./InvOnboardingLayout";
import { Box, CardMedia, Grid, Typography, useTheme } from "@mui/material";
import { ApplicationProps } from "../../redux-store/types/api-types";
import { Location } from 'history';

const routerList = [
    {
        name: 'Enter PAN Number',
        path: 'enter-pan-number',
        component: EnterPAN,
    },
    {
        name: 'Enter Mobile Number',
        path: 'enter-mobile-number',
        component: EnterMobile,
    },
    {
        name: 'Enter OTP',
        path: 'enter-otp',
        component: EnterOTP,
    },
    {
        name: 'Enter Email Id',
        path: 'enter-email-id',
        component: EnterEmailId,
    },
]

export default function InvOnboardingRoutes({
    location,
  }: {
    location: Location<{ application: ApplicationProps; firstHolderName: string }>;
  }): JSX.Element {
    const theme = useTheme()
    const history = useHistory();
    const { path } = useRouteMatch();

    const { application, firstHolderName = '' } = location.state || {};
    const { id } = application || {};

    return (
        <InvOnboardingLayout>
            <Box>
                <Box mb="25px" mt={2}>
                    <Typography variant='h1' color="text.primary">
                        {id ? 'Add Joint Holder' : 'Onboard Investor'}
                    </Typography>
                </Box>
                <Box
                    sx={{
                        p: "25px",
                        bgcolor: "background.paper",
                        boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
                        borderRadius: '25px',
                        minHeight: { xs: 'calc(100vh - 100px)', md: 'calc(100vh - 195px)' },
                        display: "flex",
                        alignItems: "stretch",
                    }}
                >
                    <Grid container sx={{ mt: id ? 1 : 0 }} rowGap={2}>
                        <Grid
                            item
                            container
                            xs={12}
                            lg={6}
                            sx={{ alignSelf: 'center', display: { xs: 'none', lg: 'flex' } }}
                        >
                            <Grid
                                item xs={3}
                            />
                            <Grid
                                item
                                xs={6}
                            >
                                <CardMedia
                                    component="img"
                                    src="/images/onboard-investor.svg"
                                    alt="Illustration"
                                    width="203px"
                                    height="203px"
                                    sx={{ objectFit: "contain" }}
                                />
                                <Typography
                                    variant='h1'
                                    component="h2"
                                    color="text.primary"
                                    textAlign="center"
                                    py={1}
                                >
                                    {id ? `Please provide joint holder details ${firstHolderName !== 'N/A' ? ` - ${firstHolderName}` : ""}` : "Onboard New Investor"}
                                </Typography>
                                <Typography
                                    variant='subtitle_400'
                                    color="text.secondary"
                                    textAlign="center"
                                >
                                    Offer essential information to facilitate the seamless onboarding of the investor.
                                </Typography>
                            </Grid>
                            <Grid
                                item xs={3}
                            />
                        </Grid>
                        <Grid
                            item
                            container
                            xs={12}
                            lg={6}
                            border={`1px solid ${theme.palette.text.secondary}26`}
                            borderRadius="15px"
                            p="35px"
                        >
                            <Grid item xs={12}>
                                <Router history={history}>
                                    <Switch>
                                        <Route
                                            exact
                                            path={path}
                                            render={() => <Redirect to={`${path}/enter-pan-number`} from={location.pathname} />}
                                        />
                                        {routerList.map((item, index) => (
                                            <Route
                                                key={index}
                                                path={`${path}/${item.path}`}
                                                component={item.component}
                                            />
                                        ))}
                                    </Switch>
                                </Router>
                            </Grid>
                        </Grid>
                    </Grid>

                </Box>
            </Box>
        </InvOnboardingLayout>
    );
}
